import { MarginType, PaddingType } from 'common/types/styleTypes'
import {
  FontProps,
  fontCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

export const CommonBookingCalendarWrapperUi = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

interface CommonCalendarContainerUiProps extends FontProps {
  padding: PaddingType
  margin: MarginType
  mobilePadding: PaddingType
  mobileMargin: MarginType
  isDateSelected: boolean
  isThankYouStep: boolean
}

export const CommonBookingCalendarInactiveUi = styled.div`
  position: absolute;
  border-radius: 6px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
`

export const CommonBookingCalendarContainerUi = styled.div<CommonCalendarContainerUiProps>`
  position: relative;
  max-width: ${p => (p.isDateSelected ? '978px' : '800px')};
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 32px;
  border-radius: 6px;

  background-color: white;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

  ${paddingsCss}
  ${fontCss}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
      flex-direction: column;
    `}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
    flex-direction: column;
  }
`
